import { createContext, useEffect, useState } from "react";
import { subDays, isAfter } from "date-fns";
import baseService from "../services/base";
import useSWR from "swr";

export const CustomContext = createContext({});

const fetcher = async (url) => {
  const response = await baseService.get(url, {
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json;charset=UTF-8",
    },
  });
  return response.data;
};

 const useResearch = (researchId) => {
  const { data, error, mutate } = useSWR(
    researchId ? `/status/${researchId}` : null,
    fetcher
  );

  return {
    data,
    isLoading: !error && !data,
    isError: error,
    mutate,
  };
};
export const putResearch = async (researchId, researchData) => {
  const response = await baseService.put(`/research/${researchId}`, researchData);
  return response;
};


export function CustomProvider({ children }) {
  const [custom, setCustom] = useState(true);
  const [id, setId] = useState();
  const [currentCompanyLogo, setCurrentCompanyLogo] = useState();
  const [systemLanguage, setSystemLanguage] = useState('pt-BR');

  const { data } = useResearch(id !== undefined ? id : undefined);

  useEffect(() => {
    if (data?.period.from) {
      const limitDate = subDays(new Date(data.period.from), 2);
      const isValid = isAfter(new Date(), limitDate);
      if (isValid) {
        setCustom(false);
      } else {
        setCustom(true);
      }
    } else {
      setCustom(true);
    }
  }, [custom, data, id]);

  useEffect(() => {
    const currentLanguage = localStorage.getItem("i18nextLng")

    if (!!currentLanguage) {
      setSystemLanguage(currentLanguage)
    }
  }, [setSystemLanguage])

  const handleCustom = () => {
    setCustom(false);
  };

  return (
    <CustomContext.Provider
      value={{
        custom,
        handleCustom,
        setId,
        currentCompanyLogo,
        setCurrentCompanyLogo,
        systemLanguage,
        setSystemLanguage,
      }}
    >
      {children}
    </CustomContext.Provider>
  );
}
